import { Component } from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';

import {AlertController, Events, LoadingController, NavController} from 'ionic-angular';

import { UserData } from '../../providers/user-data';

import { UserOptions } from '../../interfaces/user-options';

import { TabsPage } from '../tabs-page/tabs-page';
import { MissionsListPage } from '../missions/missions-list/missions-list'


@Component({
    selector: 'page-user',
    templateUrl: 'signup.html'
})
export class SignupPage {
    public static readonly pageName = "SignupPage";
    signup: UserOptions = { username: '', password: '' , firstname: '' };
    submitted = false;
    error: boolean = false;
    errorMessage: string = "";
    signupForm : FormGroup;
    submitAttempt: boolean = false;
    loading: any = false;


    constructor(
        public navCtrl: NavController,
        public alertCtrl: AlertController,
        public userData: UserData,
        private formBuilder: FormBuilder,
        public loadingCtrl: LoadingController,
        public events: Events

    ) {
        this.signupForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            firstname: ['', [Validators.required, Validators.minLength(3)]],
        });

    }
    setLoading(state){
        if(state)
        {
            this.loading = this.loadingCtrl.create({
                content: 'Connexion ...'
            });
            this.loading.present();
        }
        else if(this.loading){
            this.loading.dismiss();
        }
    }
    trimEmail()
    {
        var username = this.signup.username;
        username = username.replace(' ','');
        this.signup.username = username.trim();
    }
    onSignup(form: NgForm) {
        this.submitted = true;
        var that = this;

        if (form.valid) {
            this.setLoading(true);
            that.userData.requireProvideAfterSync();
            this.userData.signup(this.signup.username,this.signup.password,this.signup.firstname).then(value => {
                /*this.userData.load().subscribe(data => {
                    console.log('HEY');
                    this.setLoading(false);
                    this.navCtrl.push(MissionsListPage);
                    this.userData.triggerPortalSync({});
                } );*/
                /*setTimeout(function(){
                    that.setLoading(false);
                    if(!that.navCtrl.getActive() || (that.navCtrl.getActive() && that.userData.anonymousPages.indexOf(that.navCtrl.getActive().id)>=0))
                    {
                        that.navCtrl.setRoot(that.userData.loggedInDestination());
                    }
                },1000);*/
                that.setLoading(false);
                //that.userData.checkLoggedInRootPage(this.navCtrl);
                //this.userData.checkLoggedInRootPage();

            })
            .catch(err => {
                this.setLoading(false);
                console.log('LOGIN KO :',err.message,err.code);
                if(err.code == "auth/email-already-in-use") {
                    that.error = true;
                    that.errorMessage = "Cette adresse email est déjà utilisée.";
                    that.emailAlreadyUsed();
                }
                else if(err.code == "auth/invalid-email")
                {
                    that.error = true;
                    that.errorMessage = "L'adresse email fournie n'est pas une adresse email valide.";
                }
                else if(err.code == "auth/weak-password")
                {
                    that.error = true;
                    that.errorMessage = "Le mot de passe choisi n'est pas assez sécurisé, ajoutez lettres, chiffres et caractères spéciaux.";
                }
                else
                {
                    that.error = true;
                    that.errorMessage = "Une erreur s'est produite : "+err.code;
                }
            });

        }
    }
    ionViewDidEnter() {
        console.log("Login page did load");
        this.getUserInfos();
    }
    ionViewDidLoad() {
        console.log("Login page did load");
        // this.getUserInfos();
    }
    ionViewWillLeave() {
        console.log("Login page will unload");
        //this.sessionRef.unsubscribe();
        //this.userRef.unsubscribe();
    }
    getUserInfos() {
        var that = this;
        that.userData.hasLoggedIn().then(function(logged){
            if(logged)
            {
                that.events.publish('app:checkroot');
            }
        });
        /*if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session !== null) {
                    //that.navCtrl.setRoot(MissionsListPage);

                }
            });
        }*/
    }
    emailAlreadyUsed() {
        var that = this;
        let prompt = this.alertCtrl.create({
            title: 'Email déjà utilisé',
            message: "Cette adresse email est déjà inscrite sur Novaterim. Vous allez être redirigé vers la page de connexion.",
            buttons: [
                {
                    text: 'Oui',
                    handler: data => {

                        that.navCtrl.push('LoginPage');
                    }
                },
                {
                    text: 'Annuler',
                    handler: data => {

                    }
                }
            ]
        });
        prompt.present();

    }
    onCancel(form: NgForm) {

        this.navCtrl.push("LoginPage",{},{direction:'back'});
    }
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts